import { Parser } from 'htmlparser2';
import { escapeUnsupportedTags, SUPPORTED_TAGS } from './escape-unsupported-tags';

const EXCLUDED_ATTRIBUTED = ['style'];

export function decodeText(text = '') {
  return text
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&#39;/g, "'")
    .replace(/&#34;/g, '"');
}

export function createElement(jsx, textEntity, className, users = {}) {
  var root = {
    tagName: 'div',
    attributes: {
      'data-spot-im-class': 'message-text',
      className
    },
    children: [],
    parent: null
  };
  var current = root;
  let length = 0;
  var parser = new Parser({
    onopentag: function (tagName, attributes) {
      attributes = Object.keys(attributes)
        .filter(attributeName => EXCLUDED_ATTRIBUTED.indexOf(attributeName) === -1)
        .reduce((attrs, attributeName) => {
          attrs[attributeName] = attributes[attributeName];
          return attrs;
        }, {});

      if (SUPPORTED_TAGS.indexOf(tagName) > -1) {
        let component = { tagName, attributes, children: [], parent: current };
        current.children.push(component);
        current = component;
      }

      if (tagName === 'span') {
        if (attributes['data-mention']) {
          let [userId, displayName, username] = attributes['data-mention'].split(',');
          let user = users[userId];
          if (user && user.displayName) {
            ({ displayName } = user);
          }
          if (!displayName || typeof displayName !== 'string') {
            displayName = username || '';
          }

          if (user && !displayName && user.username) {
            displayName = user.username;
          }

          current.attributes.className = 'mention';
        } else if (attributes['data-text-size']) {
          current.attributes.className = (() => {
            switch (attributes['data-text-size']) {
              case 'small':
                return 'small-text-size';
              case 'normal':
                return 'normal-text-size';
              case 'large':
                return 'large-text-size';
              default:
                return undefined;
            }
          })();
        }
      } else if (tagName === 'blockquote') {
        current.attributes.className = 'blockquote';
      } else if (tagName === 'ul') {
        current.attributes.className = 'ul';
      } else if (tagName === 'ol') {
        current.attributes.className = 'ol';
      }
      if (attributes.class) {
        current.attributes.className = current.attributes.className
          ? `${current.attributes.className} ${attributes.class}`
          : attributes.class;
        delete attributes.class;
      }
    },
    ontext: function (text) {
      const decodedText = decodeText(text);
      length += decodedText.length;
      current.children.push(decodedText);
    },
    onclosetag: function (tagName) {
      if (SUPPORTED_TAGS.indexOf(tagName) > -1) {
        if (current.tagName === tagName) {
          current = current.parent;
        }
      }
    }
  });
  parser.write(escapeUnsupportedTags(textEntity));
  parser.end();

  let key = 0;
  function buildComponent({ tagName = 'div', attributes = {}, children = [] } = {}) {
    let nested = children.map(child => (typeof child === 'string' ? child : buildComponent(child)));
    return jsx(tagName, { ...attributes, key: key++ }, nested);
  }

  return [buildComponent(root), length];
}
